import React, { useState } from 'react';
import GlobalDialog from '../../../../../components/mui/Dialogue/GlobalDialog';
import { CancelButton, DeleteButton } from '../../../../../components/mui/Buttons/Buttons';
import { Box, Stack, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { deleteCourse } from '../../../../../redux/features/cartSlice';
import { useSnackbar } from 'notistack';

const DeleteCourse = ({ cartId}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  const deleteAction = () => {
    dispatch(deleteCourse(cartId)).then((res) => {
      if (res.payload.status === 'failed' || res.payload.status === 'error') {
        setOpen(false);
        enqueueSnackbar(res.payload.message, {
          variant: 'error',
        });
      } else if (res.payload.status === 'success') {
        setOpen(false);
        enqueueSnackbar(res.payload.message, {
          variant: 'success',
        });
      }
    });
  };
  return (
    <GlobalDialog
      open={open}
      setOpen={setOpen}
      title={'Delete Course'}
      closeButton={true}
      fullWidth
      maxWidth={'sm'}
      popupButton={
        <DeleteButton size={'small'} action={() => setOpen(true)}>
          Delete Course
        </DeleteButton>
      }
      content={
        <>
          <Typography>Are you sure? you want to delete this course...!</Typography>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Stack direction={'row'} spacing={1}>
              <CancelButton size={'small'} action={() => setOpen(false)}>
                Cancel
              </CancelButton>
              <DeleteButton action={deleteAction} size={'small'}>
                Delete
              </DeleteButton>
            </Stack>
          </Box>
        </>
      }
    />
  );
};

export default DeleteCourse;
